<template>
    <div>
        <top></top>
        酒店审核
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>